import axios from 'axios';

const applyTeamDefaultContact = async (
  teamId: string,
  contact: any,
  orgId: string,
) => {
  const { data } = await axios.request({
    url: `/team/default/apply/${teamId}`,
    method: 'post',
    data: {
      orgId,
      contact,
    },
  });

  return data;
};

export default applyTeamDefaultContact;
